import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://commit.you';
const DEFAULT_IMAGE = 'https://commit.you/og-image.png';
const SITE_NAME = 'commit.you';

export interface SEOConfig {
  title: string;
  description: string;
  canonical: string;
  image?: string;
  type?: 'website' | 'profile' | 'article';
  noIndex?: boolean;
}

interface SEOHeadProps {
  config: SEOConfig;
}

export function SEOHead({ config }: SEOHeadProps) {
  const {
    title,
    description,
    canonical,
    image = DEFAULT_IMAGE,
    type = 'website',
    noIndex = false,
  } = config;

  const fullTitle = `${title} - ${SITE_NAME}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card */}
      <meta name="twitter:card" content={type === 'profile' ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export { BASE_URL, DEFAULT_IMAGE, SITE_NAME };
